export const APPOINTMENT_STATUSES = {
  pending: 'pendiente',
  confirmed: 'confirmada',
  waitingRoom: 'sala_espera',
  inProgress: 'en_atencion',
  attended: 'atendida',
  cancelled: 'cancelada',
  rescheduled: 'reprogramada',
  noShow: 'no_asistio',
};

export const appointmentStatusLabels = {
  pendiente: 'Pendiente',
  confirmada: 'Confirmada',
  sala_espera: 'En sala de espera',
  en_atencion: 'En atencion',
  atendida: 'Atendida',
  cancelada: 'Cancelada',
  reprogramada: 'Reprogramada',
  no_asistio: 'No asistio',
  scheduled: 'Pendiente',
  confirmed: 'Confirmada',
  active: 'En atencion',
  completed: 'Atendida',
  cancelled: 'Cancelada',
  rescheduled: 'Reprogramada',
  no_show: 'No asistio',
};

const legacyStatusMap = {
  scheduled: APPOINTMENT_STATUSES.pending,
  confirmed: APPOINTMENT_STATUSES.confirmed,
  active: APPOINTMENT_STATUSES.inProgress,
  completed: APPOINTMENT_STATUSES.attended,
  cancelled: APPOINTMENT_STATUSES.cancelled,
  rescheduled: APPOINTMENT_STATUSES.rescheduled,
  no_show: APPOINTMENT_STATUSES.noShow,
};

export const normalizeAppointmentStatus = (status = APPOINTMENT_STATUSES.pending) => (
  legacyStatusMap[status] || (appointmentStatusLabels[status] ? status : APPOINTMENT_STATUSES.pending)
);

export const getAppointmentStatusLabel = (status) => (
  appointmentStatusLabels[normalizeAppointmentStatus(status)] || 'Pendiente'
);

export const isUpcomingAppointment = (status) => (
  [
    APPOINTMENT_STATUSES.pending,
    APPOINTMENT_STATUSES.confirmed,
    APPOINTMENT_STATUSES.waitingRoom,
    APPOINTMENT_STATUSES.inProgress,
    APPOINTMENT_STATUSES.rescheduled,
  ].includes(normalizeAppointmentStatus(status))
);
